import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import JenisPengikatanService from "services/Setup/Organization/jenisPengikatanService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  JenisPengikatanList: {},
  refreshList: false,
  JenisPengikatanApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postJenisPengikatan = createAsyncThunk(
  "jenisPengikatan/postJenisPengikatan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.postJenisPengikatan(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getJenisPengikatanList = createAsyncThunk(
  "jenisPengikatan/getJenisPengikatanList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.getJenisPengikatanList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getJenisPengikatanApprovalList = createAsyncThunk(
  "jenisPengikatan/getJenisPengikatanApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await JenisPengikatanService.getJenisPengikatanApprovalList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putJenisPengikatanApproval = createAsyncThunk(
  "jenisPengikatan/putJenisPengikatanApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.putJenisPengikatanApproval(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putJenisPengikatanRequest = createAsyncThunk(
  "jenisPengikatan/putJenisPengikatanRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.putJenisPengikatanRequest(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getJenisPengikatanDetail = createAsyncThunk(
  "jenisPengikatan/getJenisPengikatanDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.getJenisPengikatanDetail(
        data
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateJenisPengikatan = createAsyncThunk(
  "jenisPengikatan/updateJenisPengikatan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.updateJenisPengikatan(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteJenisPengikatan = createAsyncThunk(
  "jenisPengikatan/deleteJenisPengikatan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await JenisPengikatanService.deleteJenisPengikatan(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const JenisPengikatanSlice = createSlice({
  name: "jenisPengikatan",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postJenisPengikatan.pending, (state) => {
        state.loading = true;
      })
      .addCase(postJenisPengikatan.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postJenisPengikatan.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getJenisPengikatanList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJenisPengikatanList.fulfilled, (state, action) => {
        state.loading = false;
        state.JenisPengikatanList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getJenisPengikatanList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //JenisPengikatan approval list
      .addCase(getJenisPengikatanApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJenisPengikatanApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.JenisPengikatanApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getJenisPengikatanApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.JenisPengikatanApprovalList = action.payload;
      })

      //JenisPengikatan approval approve
      .addCase(putJenisPengikatanApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putJenisPengikatanApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putJenisPengikatanApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //JenisPengikatan approval request
      .addCase(putJenisPengikatanRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putJenisPengikatanRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putJenisPengikatanRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getJenisPengikatanDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJenisPengikatanDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getJenisPengikatanDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateJenisPengikatan.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateJenisPengikatan.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateJenisPengikatan.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteJenisPengikatan.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteJenisPengikatan.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteJenisPengikatan.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = JenisPengikatanSlice.actions;

export default JenisPengikatanSlice.reducer;
